<template>
  <section
    class="service-content"
    :class="{'fina-blue':isFina}">
    <div class="flex-sb-center">
      <div class="flex-align-center flex">
        <span class="icon">
          <img
            v-if="!isFina"
            src="@/assets/images/icon/hc.png">
          <img
            v-else
            src="@/assets/images/icon/Fina.png">
        </span>
        <span class="text fs-14 fw-600">Serviced by {{isFina?'Fina':'HoldCover'}}</span>
      </div>
      <span
        v-if="agencyName"
        class="text fs-14 fw-600">{{agencyName}}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'v-serviced-progress',
  props:{
    isFina:{
      type:Boolean,
      default:false
    },
    agencyName:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped lang="scss">
.service-content{
  background: #FFE000;
  color: $dark;
  width: 100%;
  padding: 8px;
  border-radius: 8px;

  .icon{
    width: 22px;
    height: 22px;
    display: block;
    margin-right: 8px;
    img{
      width: 22px;

    }
  }
  &.fina-blue{
    background: #012A63;
    color: white;
  }

}
</style>
